import React, { useState, useContext } from "react"
import Fab from "@mui/material/Fab"
import { ArrowUpward } from "@mui/icons-material"

import { ThemeContext } from "../context/theme/context"

const FloatingActionButton = () => {
    const { state } = useContext(ThemeContext)
    const [visible, setVisible] = useState(false)

    const toggleVisible = () =>
        document.documentElement.scrollTop > 300
            ? setVisible(true)
            : setVisible(false)
    window.addEventListener('scroll', toggleVisible)

    return <Fab
        aria-label="Up"
        sx={{
            position: "fixed",
            bottom: { xs: 80, sm: 50 },
            right: 35,
            bgcolor: state.color.cold,
            display: visible ? 'inline-flex' : 'none',
            "&:hover": { bgcolor: state.color.dark },
            "&:focus": {
                transition: "all 0.15s linear",
                transform: 'translateY(-15px)'
            }
        }}
        onClick={() => window.scrollTo(0, 0)}
    >
        <ArrowUpward sx={{ color: '#FCFCFC' }} />
    </Fab >
}

export default FloatingActionButton